import React from 'react';
import OtpInput from 'react-otp-input';

import { lang } from 'src/helpers';

class OtpField extends React.PureComponent {
  onChanged = (v) => {
    const { name, onChange } = this.props;
    onChange(name, v);
  };

  render() {
    let {
      label,
      labelHtml,
      template = 6,
      value,
      name,
      inputTestId,
      placeholder = '',
      invalid,
      readOnly,
      onChange,
      prefixEl = null,
      suffixEl = null,
      disabled = false,
      shouldAutoFocus = false,
      numInputs = 6,
      containerStyle = 'mc-flex-10',
      inputType,
      ...other
    } = this.props;

    let inputEl = (
      <OtpInput
        shouldAutoFocus={shouldAutoFocus}
        placeholder={placeholder}
        numInputs={numInputs}
        skipDefaultStyles={true}
        inputType={inputType}
        containerStyle={containerStyle}
        inputStyle={`mc-input-box ${invalid[name] ? 'invalid' : 'valid'}`}
        value={value}
        onChange={onChange ? this.onChanged : undefined}
        renderInput={(props) => (
          <div className={'mc-input-box-cover'}>
            <input
              {...props}
              data-testid={inputTestId || (name ? `input-${name}` : undefined)}
              disabled={disabled}
              readOnly={readOnly}
            />
          </div>
        )}
      />
    );

    return (
      <div className={'mc-text-field-group template-' + template} {...other}>
        {labelHtml && <label>{labelHtml}</label>}
        {label && <label>{lang.t(label)}</label>}
        <div className={'mc-flex-10'}>
          {prefixEl}
          {inputEl}
          {suffixEl}
        </div>
        {invalid[name] && <p className='mc-form-invalid-text'>{invalid[name]}</p>}
      </div>
    );
  }
}

export default OtpField;
